import _lib from '../_lib';
import active from './active/index';
import {ProceduresNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'procedures';
  let activations = [
    {
      name: 'procedures',
      test: api.messageIs(ProceduresNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};

